import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TabPanel from '../../components/TabPanel';
import Overview from '../../pages/issuer/Investors/Overview';
import Communications from '../../pages/issuer/Investors/Communications';
import Invite from '../../pages/issuer/Investors/Invite';
import UploadDocuments from '../../pages/issuer/Investors/UploadDocuments';
import KycPage from '../../pages/issuer/Investors/KycPage';
import Distributions from '../../pages/issuer/Investors/Distributions';

import VerticalContainer from '../../components/VerticalContainer';

const InvestorRoutes = () => {
    let { path } = useRouteMatch();

    return (
        <VerticalContainer>
            <TabPanel>
                <Switch>
                    <Route exact path={`${path}/`} component={Overview} />
                    <Route
                        exact
                        path={`${path}/events`}
                        component={Communications}
                    />
                    <Route exact path={`${path}/kyc`} component={KycPage} />
                    <Route
                        exact
                        path={`${path}/documents`}
                        component={UploadDocuments}
                    />
                    <Route
                        exact
                        path={`${path}/distributions`}
                        component={Distributions}
                    />
                    {/*<Route exact path={`${path}/wallets`} component={Wallets} />*/}
                    <Route exact path={`${path}/invite`} component={Invite} />
                    {/* <Route
                        exact
                        path={`${path}/investor-view`}
                        component={InvestorView}
                    /> */}
                </Switch>
            </TabPanel>
        </VerticalContainer>
    );
};

export default InvestorRoutes;
